/* Assets/product-zalando.js */
/* CORRETTO: Compatibile con Spotlight, logica varianti aggiornata */

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.zalando-product-page').forEach(section => {
    
    // --- VARIABILI GLOBALI ---
    const productForm = section.querySelector('[data-product-form]');
    const allVariants = JSON.parse(document.querySelector('[data-product-variants]').textContent);
    const thumbnails = section.querySelectorAll('.thumbnail-item');
    const mainImages = section.querySelectorAll('.main-image-item');
    const optionInputs = section.querySelectorAll('[data-option-value]');
    const variantIdInput = section.querySelector('[data-variant-id]');
    const addToCartBtn = section.querySelector('[data-add-to-cart-btn]');
    const messageEl = section.querySelector('.add-to-cart-message');
    const priceEl = section.querySelector('[data-sale-price]');
    const comparePriceEl = section.querySelector('[data-compare-price]');

    // --- 1. GESTIONE GALLERIA IMMAGINI ---
    const updateGallery = (mediaId) => {
      if (!mediaId) return;
      const mediaIdStr = mediaId.toString();

      const activeImage = section.querySelector(`.main-image-item[data-media-id="${mediaIdStr}"]`);
      if (!activeImage) return;

      mainImages.forEach(img => img.classList.remove('active'));
      activeImage.classList.add('active');

      thumbnails.forEach(t => t.classList.remove('active'));
      const activeThumb = section.querySelector(`.thumbnail-item[data-media-id="${mediaIdStr}"]`);
      if (activeThumb) {
        activeThumb.classList.add('active');
        activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    };

    // Event listener per thumbnails
    thumbnails.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const mediaId = thumb.dataset.mediaId;
        updateGallery(mediaId);
      });
    });

    // --- 2. GESTIONE VARIANTI ---
    const getSelectedVariant = () => {
      const selectedValues = Array.from(optionInputs)
        .filter(input => input.checked)
        .map(input => input.value);

      return allVariants.find(variant => {
        return variant.options.every((option, index) => option === selectedValues[index]);
      });
    };

    const updateVariantUI = () => {
      const variant = getSelectedVariant();
      if (!variant) return;

      // Aggiorna ID variante nel form
      variantIdInput.value = variant.id;

      // Aggiorna galleria
      if (variant.featured_media) {
        updateGallery(variant.featured_media.id);
      }

      // Aggiorna prezzi
      updatePrice(variant);

      // Aggiorna bottone
      updateButton(variant);

      // Aggiorna legend con valori selezionati
      const optionGroups = section.querySelectorAll('.variant-option-group');
      optionGroups.forEach((group, index) => {
        const legendSpan = group.querySelector('.selected-option-value');
        if (legendSpan) {
          legendSpan.textContent = variant.options[index];
        }
      });

      // Dispatch evento per notificare il tema
      productForm.dispatchEvent(new CustomEvent('variant-change', {
        bubbles: true,
        detail: { variant: variant }
      }));
    };

    // Event listener per i radio button
    optionInputs.forEach(input => {
      input.addEventListener('change', updateVariantUI);
    });

    // --- 3. ACCORDION ---
    const toggles = section.querySelectorAll('.accordion-toggle');
    toggles.forEach(toggle => {
      toggle.addEventListener('click', () => {
        const content = toggle.nextElementSibling;
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        
        if (isExpanded) {
          toggle.setAttribute('aria-expanded', 'false');
          content.style.maxHeight = null;
        } else {
          toggle.setAttribute('aria-expanded', 'true');
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    });

    // --- 4. ADD TO CART (AJAX) ---
    if (productForm) {
      productForm.addEventListener('submit', (event) => {
        event.preventDefault();

        addToCartBtn.classList.add('is-loading');
        addToCartBtn.disabled = true;
        messageEl.classList.remove('is-visible', 'is-success', 'is-error');

        const formData = new FormData(productForm);

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === 'error' || data.status >= 400) {
            throw new Error(data.description || 'Errore aggiunta al carrello');
          }

          // Successo
          messageEl.textContent = 'Prodotto aggiunto al carrello ✓';
          messageEl.className = 'add-to-cart-message is-visible is-success';

          // Notifica il tema
          document.dispatchEvent(new CustomEvent('cart:updated', {
            bubbles: true,
            detail: data
          }));

          // Reset
          setTimeout(() => {
            addToCartBtn.classList.remove('is-loading');
            addToCartBtn.disabled = false;
          }, 1500);
        })
        .catch(error => {
          messageEl.textContent = error.message;
          messageEl.className = 'add-to-cart-message is-visible is-error';

          addToCartBtn.classList.remove('is-loading');
          addToCartBtn.disabled = false;
        });
      });
    }

    // --- FUNZIONI HELPER ---
    function updatePrice(variant) {
      if (!variant) {
        priceEl.textContent = '';
        if (comparePriceEl) comparePriceEl.style.display = 'none';
        return;
      }

      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price);
      }
      if (comparePriceEl) {
        if (variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.style.display = 'inline-block';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
    }

    function updateButton(variant) {
      if (!addToCartBtn) return;

      const btnText = addToCartBtn.querySelector('.btn-text');
      if (variant && variant.available) {
        addToCartBtn.disabled = false;
        btnText.textContent = 'Aggiungi al carrello';
      } else {
        addToCartBtn.disabled = true;
        btnText.textContent = 'Esaurito';
      }
    }

    function formatMoney(cents) {
      const value = (cents / 100).toFixed(2);
      return `€${value.replace('.', ',')}`;
    }

  });
});